var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.018 14.422a.833.833 0 0 0 1.18 0l5.607-5.607c.26-.26.26-.68 0-.94L6.198 2.268a.833.833 0 0 0-1.18 0 .833.833 0 0 0 0 1.18l4.894 4.894-4.9 4.9a.84.84 0 0 0 .006 1.18"
  })));
};
export default SvgChevronRight;